module.exports = __webpack_public_path__ + "img/insightful.d1c735b6.gif";